import { UnorderedList, ListItem } from '@chakra-ui/react';
import { PlanProps } from '@/components/PricingPlan/types';
import React from 'react';

const FreePlanBreakdown: React.FC<PlanProps> = ({ t }) => {
  return (
    <UnorderedList>
      <ListItem color="blue.500" fontSize="sm">
        {t('pricing_info_available_seats_free')}
      </ListItem>
      <ListItem color="blue.500" fontSize="sm" mt="2">
        {t('pricing_info_data_transaction_free')}
      </ListItem>
      <ListItem color="blue.500" fontSize="sm" mt="2">
        {t('change_to_developer_plan_for_extending')}
      </ListItem>
      <ListItem color="blue.500" fontSize="sm" mt="2">
        {t('basic_technical_support')}
      </ListItem>
    </UnorderedList>
  );
};

export default FreePlanBreakdown;
